<template>
  <section class="custom-wrapper">
    <div class="row">
      <div class="col-md-12">
        <h5>Zone Settings History</h5>
      </div>
    </div>
    <z-table
      :value="zones"
      sortBy="id"
      orderBy="asc"
      :columns="tableColumns"
      :isSingleRowDetail="false"
      class="table table-bordered table-striped"
    >
      <template v-slot:tbody="props">
        <td
          class="z-column-60-center"
          :class="{ 'custom-highlight': props.row.isHighlight }"
        >
          <div v-if="props.row.isEditable">
            <button class="btn btn-link" @click="editProgram(props.row)">
              <i class="fas fa-pencil-alt"></i>
            </button>
          </div>
        </td>
        <td
          class="z-column-60-center"
          :class="{ 'custom-highlight': props.row.isHighlight }"
        >
          <div v-if="props.row.isEditable">
            <button class="btn btn-link" @click="removeProgram(props.row)">
              <i class="far fa-trash-alt"></i>
            </button>
          </div>
        </td>
        <th
          scope="row"
          v-html="props.row.dateRange"
          :class="{ 'custom-highlight': props.row.isHighlight }"
        ></th>
        <td
          class="z-column-110-right"
          :class="{ 'custom-highlight': props.row.isHighlight }"
        >
          {{ props.row.totalTime }}
        </td>
        <td
          class="z-column-120-center"
          :class="{ 'custom-highlight': props.row.isHighlight }"
        >
          {{ props.row.belowTime }}
        </td>
        <td
          class="z-column-120-center"
          :class="{ 'custom-highlight': props.row.isHighlight }"
        >
          {{ props.row.inTime }}
        </td>
        <td
          class="z-column-120-center"
          :class="{ 'custom-highlight': props.row.isHighlight }"
        >
          {{ props.row.aboveTime }}
        </td>
        <td
          class="z-column-80-right"
          :class="{ 'custom-highlight': props.row.isHighlight }"
        >
          {{ props.row.maxHR }}
        </td>
        <td :class="{ 'custom-highlight': props.row.isHighlight }">
          {{ props.row.createdOn }}
        </td>
        <td :class="{ 'custom-highlight': props.row.isHighlight }">
          {{ props.row.createdBy }}
        </td>
      </template>
      <template v-slot:empty> Nothing found! </template>
    </z-table>
  </section>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'
import globals from '@/Plugins/globals'
import ZTable from '@/Components/ZElements/Table'
export default {
  name: 'heartrate-history',
  components: {
    ZTable,
  },
  props: {
    currentProgram: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isFirstRecord: true,
      lastStartDate: null,
    }
  },
  mounted() {
    this.isFirstRecord = true
    this.lastStartDate = null
  },
  watch: {
    currentProgram() {
      this.$forceUpdate()
    },
  },
  emits: ['edit', 'remove'],
  computed: {
    ...mapGetters('usercardio', ['zoneProfile']),
    tableColumns() {
      return [
        {
          field: 'id',
          label: '',
          sortable: false,
          class: 'z-column-60-center',
        },
        {
          field: 'id',
          label: '',
          sortable: false,
          class: 'z-column-60-center',
        },
        { field: 'date', label: 'Dates', sortable: false },
        {
          field: 'totalTime',
          label: 'Total Time (min)',
          sortable: false,
          class: 'z-column-110-center',
        },
        {
          field: 'belowZone',
          label: 'Below Zone (min)',
          sortable: false,
          class: 'z-column-120-center',
        },
        {
          field: 'inZone',
          label: 'In Zone (min)',
          sortable: false,
          class: 'z-column-120-center',
        },
        {
          field: 'aboveZone',
          label: 'Above Zone (min)',
          sortable: false,
          class: 'z-column-120-center',
        },
        {
          field: 'maxHR',
          label: 'Max HR',
          sortable: false,
          class: 'z-column-80-center',
        },
        { field: 'createdOn', label: 'Created on', sortable: false },
        { field: 'createdBy', label: 'Created by', sortable: false },
      ]
    },
    zones() {
      let _zones = []
      if (this.zoneProfile) {
        _zones = this.prepZones()
      }
      return _zones
    },
  },
  methods: {
    isEditable(d) {
      let is = false
      let today = new Date()
      let thisMonday = globals.getMonday(today)
      let firstMonday = new Date(thisMonday)
      firstMonday.setDate(firstMonday.getDate() - 14)
      let lastMonday = new Date(thisMonday)
      lastMonday.setDate(lastMonday.getDate() + 21)
      if (
        d.getTime() >= firstMonday.getTime() &&
        d.getTime() < lastMonday.getTime()
      ) {
        is = true
      }
      return is
    },
    calcTotalTime(zone) {
      let total = 0
      total =
        parseFloat(zone.MinutesBelowZone) +
        parseFloat(zone.MinutesInZone) +
        parseFloat(zone.MinutesAboveZone)
      return total
    },
    prepZones() {
      let zones = []
      let isFirst = true
      let last = ''
      if (this.zoneProfile) {
        this.zoneProfile.usercardioprograms.forEach((zone) => {
          let range = this.setStartDate(zone, isFirst, last)
          zones.push({
            id: zone.id,
            startDate: range.monday,
            dateRange: range.display,
            totalTime: this.calcTotalTime(zone).toFixed(1),
            belowTime: this.setBelowTime(zone),
            inTime: this.setInZone(zone),
            aboveTime: this.setAboveZone(zone),
            maxHR: zone.HRmax,
            createdOn: moment(zone.created_at).format('MM/DD/YYYY'),
            createdBy: zone.created_by,
            isEditable: this.isEditable(range.monday),
            isHighlight: range.highlight,
          })
          isFirst = false
          last = range.last
        })
      }
      return zones
    },
    setBelowTime(zone) {
      let total = this.calcTotalTime(zone)
      let percent = 0
      if (total !== 0) {
        percent = ((parseFloat(zone.MinutesBelowZone) / total) * 100).toFixed(0)
      }
      return `${zone.MinutesBelowZone.toFixed(1)} / ${percent}%`
    },
    setInZone(zone) {
      let total = this.calcTotalTime(zone)
      let percent = 0
      if (total !== 0) {
        percent = ((parseFloat(zone.MinutesInZone) / total) * 100).toFixed(0)
      }
      return `${zone.MinutesInZone.toFixed(1)} / ${percent}%`
    },
    setAboveZone(zone) {
      let total = this.calcTotalTime(zone)
      let percent = 0
      if (total !== 0) {
        percent = ((parseFloat(zone.MinutesAboveZone) / total) * 100).toFixed(0)
      }
      return `${zone.MinutesAboveZone.toFixed(1)} / ${percent}%`
    },
    setStartDate(zone, isFirst, lastDate) {
      let data = {
        display: null,
        last: null,
        monday: null,
        highlight: false,
      }
      let monday = new Date(zone.StartDate)
      if (isFirst) {
        data.display = `${monday.getMonth() + 1}/${monday.getDate()} - &infin;`
      } else {
        data.display = `${
          monday.getMonth() + 1
        }/${monday.getDate()} - ${lastDate}`
      }
      let previousDay = new Date()
      previousDay.setTime(monday.getTime() - 24 * 3600000)
      data.last = `${previousDay.getMonth() + 1}/${previousDay.getDate()}`
      data.monday = new Date(zone.StartDate)
      if (
        `${monday.getMonth() + 1}/${monday.getDate()}` === this.currentProgram
      ) {
        data.highlight = true
      }
      return data
    },
    editProgram(row) {
      this.$emit('edit', row)
    },
    removeProgram(row) {
      this.$emit('remove', row)
    },
  },
}
</script>
<style lang="scss" scoped>
.custom-highlight {
  background-color: rgba(255, 255, 0, 0.3);
}
</style>
